/*
export interface ApiCNRPriceResponse {
  current: {
    price: number
    priceInDecimal: number
  }
  next: { price: number; priceInDecimal: number }
}
*/
export interface ApiCNRPriceResponse {
  current: number
  next: number
}

export interface ApiInfoResponse {
  rise: {
    circulatingSupply: string
    totalBurnt: string
    maximumSupply: string
    quarantined: string
    activeSupply: string
  }
  swap: { circulatingSupply: string; totalBurnt: string }
}

export interface GeckoCNSPriceResponse {
  ['centric-cash']: {
    usd: number
  }
}

export enum CentricItemStatus {
  READY = 'READY',
  LOADING = 'LOADING',
  FINISHED = 'FINISHED',
  ERROR = 'ERROR',
}

export interface CentricCNRPrice {
  data?: {
    current: string
    next: string
  }
  isInitialized?: boolean
  expiry?: number
  status: CentricItemStatus
}

export interface CentricInfo {
  data?: {
    cnrCirculating: string
    cnrBurnt: string
    cnrMax: string
    cnrQuarantined: string
    cnrActive: string
    cnsCirculating: string
    cnsBurnt: string
  }
  isInitialized?: boolean
  expiry?: number
  status: CentricItemStatus
}

export interface CentricCNSPrice {
  data?: {
    current: number
  }
  isInitialized?: boolean
  expiry?: number
  status: CentricItemStatus
}

export interface CentricState {
  cnrPrice: CentricCNRPrice
  info: CentricInfo
  cnsPrice: CentricCNSPrice
}
